<template>
  <div
    ref="container"
    :style="{
    top: `${content.y}px`,
    left: `${content.x}px`,
    position: 'fixed',
    zIndex: index,
    fontFamily: content.mainFont,
    fontSize: `${content.mainFontSize}px`,
    backgroundColor: (content.backgroundColor && content.backgroundColor.hexa) ? content.backgroundColor.hexa : null,
    color: (content.foreGroundColor && content.foreGroundColor.hexa) ? content.foreGroundColor.hexa : null,
    transform: content.transform,
        width: `${content.width || 200}px`,
        height: content.height ? `${content.height}px` : null,
    }"
    :class="{
        widgetSelected: isSelected
    }"
  >
   <div tabindex="1" :class="{
           'edit-overlay':true,
            selected: isSelected
      }"></div>
    <slot></slot>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Hammer from "hammerjs";

export default {
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    action: {
      type: Function
    },
    isSelected: {
      type: Boolean
    },
    index: {
      type: Number
    }
  },

  mounted() {
    this.$nextTick(() => {
      let hammer = new Hammer.Manager(this.$refs.container, {});

      let doubleTap = new Hammer.Tap({ event: "doubletap", taps: 2 });
      let singleTap = new Hammer.Tap({ event: "singletap" });
      let pan = new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 0 });

      doubleTap.recognizeWith(singleTap);
      singleTap.requireFailure(doubleTap);
      pan.requireFailure(singleTap);
      

      hammer.add([doubleTap, singleTap,pan ]);
      hammer.on("pan", ()=>{
        
      });
      hammer.on("doubletap", ev => {
        this.action(2);
      });

      hammer.on("singletap", ev => {
        //        this.action(2);
        
        this.selectComponent(this.content.uuid);
      });
    });
  },

  methods: {
    ...mapActions("editor", ["selectComponent"])
  }
};
</script>

<style  lang="scss">

.edit-overlay {
    align-items: center;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    position: absolute;;
    &:focus {
      border: 5px dotted hsl(31°, 100%, 71%);
    }

    width: calc(100% + 10px);
    height: calc(100% + 10px);
    top: -5px;
    left: -5px;
    z-index: 3000;
    background: none;

    &:hover {
     // border: 5px dotted #4af;
    }

    &.selected {
      border: 5px solid #4af;
      
    }
  }

</style>